import React from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const FilterBar = ({ searchQuery, onSearchChange, statusFilter, onStatusChange, resultsCount }) => {
  const statusOptions = [
    { value: 'all', label: 'Tüm Rotalar' },
    { value: 'active', label: 'Aktif Rotalar' },
    { value: 'inactive', label: 'Pasif Rotalar' }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-4 space-y-4 md:space-y-0 md:flex md:items-end md:gap-4">
      <div className="flex-1">
        <Input
          type="search"
          placeholder="Rota adı, başlangıç veya bitiş noktası ara..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e?.target?.value)}
        />
      </div>
      <div className="w-full md:w-64">
        <Select
          options={statusOptions}
          value={statusFilter}
          onChange={onStatusChange}
          placeholder="Durum seç"
        />
      </div>
      {resultsCount !== null && (
        <div className="flex items-center gap-2 px-4 py-2 bg-muted rounded-lg">
          <Icon name="Filter" size={16} color="var(--color-muted-foreground)" />
          <span className="text-sm text-muted-foreground whitespace-nowrap">
            {resultsCount} sonuç
          </span>
        </div>
      )}
    </div>
  );
};

export default FilterBar;